import { Injectable } from '@angular/core';
import { BehaviorSubject, from } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { OrderDTO } from 'ticket-sdk';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root'
})
export class UnauthenticatedPurchasesService {

  unauthenticatedPurchases: BehaviorSubject<OrderDTO[]> = new BehaviorSubject([]);

  constructor(private storage: Storage) {
    from(this.storage.ready()).pipe(
      take(1),
      switchMap(() => from(this.storage.get('unauthenticated-purchases')).pipe(map((unauthenticatedPurchases: OrderDTO[]) => {
        if (!!unauthenticatedPurchases) {
          this.unauthenticatedPurchases.next(unauthenticatedPurchases);
        }
      })))
    ).subscribe();
  }

  getUnauthenticatedPurchases(): BehaviorSubject<OrderDTO[]> {
    return this.unauthenticatedPurchases;
  }

  onNewPurchase(order: OrderDTO) {
    if (! this.unauthenticatedPurchases.value.find(up => up.orderId === order.orderId)) {
      let newUnauthenticatedPurchases: OrderDTO[] = [ ...this.unauthenticatedPurchases.value ];

      newUnauthenticatedPurchases.push(order);
      
      this.unauthenticatedPurchases.next(newUnauthenticatedPurchases);
      this.storage.set('unauthenticated-purchases', newUnauthenticatedPurchases); 
    }
  }
}
